import { InvoicesInterface } from '../../../types/invoices';

export const invoicesInitialState: InvoicesInterface = {
  invoices: [],
};
